import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError, setToken } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/auth/me").then(() => navigate("/admin")).catch(() => {});
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data?.access_token) setToken(data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F6F7F3] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm border border-[#DFE5DC] bg-white p-10 shadow-sm">
        <p className="font-display text-3xl mb-1 tracking-tight text-[#0F1F1A]">
          Trusted <span className="italic text-[#0C6B4F]">Financial Hub</span>
        </p>
        <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#8A978D] mb-10">Admin Console</p>
        <form onSubmit={submit} className="flex flex-col gap-4" data-testid="admin-login-form">
          <input className="a-input" type="email" placeholder="Email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
          <input className="a-input" type="password" placeholder="Password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" />
          {error && (
            <p className="text-[#D92D20] text-xs font-mono2" data-testid="admin-login-error">{error}</p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="bg-[#0C6B4F] text-white text-xs font-semibold uppercase tracking-[0.2em] py-3.5 rounded-full hover:bg-[#0A5C43] active:scale-[0.98] disabled:opacity-60 transition-[background-color,transform,opacity] duration-300"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
